import { Row } from '@riac/design-system';
import styled from 'styled-components';

export const AddressBlockStyled = styled.div`
  display: flex;
  padding: 2px;
  padding-bottom: 2rem;
  flex-direction: column;
  h3 {
    display: inline-block;
  }
  ${({ theme }) => theme.tablet} {
    padding: 5px;
    padding-bottom: 2rem;
    min-width: 240px;
  }
`;

export const AddressBookConfirmAddressModalOptionContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 4px;
  h4 {
    padding: 0;
  }
  p {
    color: rgba(0, 0, 0, 0.7);
  }
`;

export const AddressFormRow = styled(Row)`
  max-width: 700px;
  &>* {
    margin-left: 5px;
    margin-right: 5px;
  }
`;

export const AddressBookContainer = styled.div`
  padding: 15px;
  margin-bottom: 100px;
`;
